export enum MenuGroups {
  Complete = 'complete',
  Edit = 'edit',
  Lifecycle = 'lifecycle',
  Restore = 'restore',
}

export enum SubMenu {
  Priority = 'priority',
  LinkedItem = 'linked-item',
  DeadlineDeadline = 'deadline-deadline',
  ReminderTime = 'reminder-time',
  Date = 'date',
  Tags = 'tags',
}
